import { useStore } from "vuex"
import { computed, onMounted, onUnmounted } from "vue"
import GetLabel from "foundation/js/getLabel"
import ProductsCardsSlider from "components/ProductsCardsSlider/ProductsCardsSlider.vue"

export default {
    name: "ProductAddedOverlay",
    components:{
        ProductsCardsSlider
    },
    setup(){
        const store = useStore()

        const variantSku = computed(() => store.state.main.page_overlay_content_data.variantSku)
        const productCode = computed(() => store.state.main.page_overlay_content_data.productCode)
        const maxRecommendations = computed(() => store.state.main.page_overlay_content_data.maxRecommendations)
        const footerRightCtaUrl = computed(() => store.state.main.page_overlay_content_data.footerRightCtaUrl)

        const recommendations = computed(() => store.state.basket.recommendations)

        const sliderDisplayType = computed(() => {
            if (recommendations.value && recommendations.value.length > 0) {
                const firstItem = recommendations.value[0];
                return firstItem.type === 'Product' ? 'products' : 'materials';
            }
            return 'products';
        })

        const getLabel = (labelKey) => GetLabel({ labelKey, labelCollection: 'ProductAddedOverlay' })

        onMounted(() => {
            store.dispatch("basket/getRecommendations", {
                variantCode: variantSku.value,
                productCode: productCode.value,
                take: maxRecommendations.value ?? 10
            })
        })

        onUnmounted(() => {
            store.commit('basket/clear_recommendations')
        })

        const sliderSizingFunction = (viewportWidth) => {

            if (viewportWidth <= 475) 
                return {
                    perView: sliderDisplayType.value === 'products' ? 1.5 : 2,
                    gap: 30,
                    peek: {
                        after: 40,
                        before: 0
                    }
                }

            if (viewportWidth <= 768) 
                return {
                    perView: sliderDisplayType.value === 'products' ? 1.75 : 2.5,
                    gap: 40,
                    peek: {
                        after: 50,
                        before: 0
                    }
                }

            return {
                perView: sliderDisplayType.value === 'products' ? 2 : 3,
                gap: 50,
                peek: {
                    after: 60,
                    before: 0
                }
            };
        }

        const closeOverlay = () => {
            store.dispatch('main/closePageOverlay')
        }

        return {
            getLabel,
            sliderDisplayType,
            recommendations,
            maxRecommendations,
            footerRightCtaUrl,
            sliderSizingFunction,
            closeOverlay
        }
    }
}